export default function () {
    return process.browser ? window.navigator.userAgent.match(/iPhone|iPad|iPod/i) : '';
}
